import { render, staticRenderFns } from "./SizeRecommendationLoadingView.vue?vue&type=template&id=50f56f24&scoped=true"
import script from "./SizeRecommendationLoadingView.vue?vue&type=script&lang=js"
export * from "./SizeRecommendationLoadingView.vue?vue&type=script&lang=js"
import style0 from "./SizeRecommendationLoadingView.vue?vue&type=style&index=0&id=50f56f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f56f24",
  null
  
)

export default component.exports